import React, { FC } from 'react';
import { AdjustFrame } from '../../components/adjust-frame';
import config from '../../config/path';
import { SpinnerWrapper } from '../../components/spinner-wrapper';
import { useUser } from '../../hooks/useUser';
import { TokenFallback } from '../../components/token-fallback';
import styles from './preliminary-application-cta-new.module.scss';

export const PreliminaryApplicationCTANew: FC = () => {
    const {
        token,
        refreshToken,
        culture,
        isAuthReady,
        isUserLoading,
        isLoading,
        error,
        handleIframeLoad,
    } = useUser();

    if (error) {
        return <div>{error.message}</div>;
    }

    if (!isAuthReady) {
        return (
            <TokenFallback
                isUserLoading={isUserLoading}
                containerClassName={styles.iframeContainer}
                spinnerOverlayClassName={styles.spinnerOverlay}
                emptyStateClassName={styles.emptyState}
            />
        );
    }

    const iframeUrl = `${config.PRICE_DEC_API}/application-cta/iframe?token=${token}&refreshToken=${refreshToken}&culture=${culture}`;
    const allowedOrigin = (() => {
        try {
            return new URL(config.PRICE_DEC_API).origin;
        } catch {
            return undefined;
        }
    })();

    return (
        <div className={styles.iframeContainer}>
            {isLoading && (
                <div className={styles.spinnerOverlay}>
                    <SpinnerWrapper size="default" spinning={isLoading} />
                </div>
            )}
            {iframeUrl && (
                <AdjustFrame
                    key={iframeUrl}
                    src={iframeUrl}
                    allowedOrigin={allowedOrigin}
                    expectedMessageType="IFRAME_SIZE"
                    requestType="REQUEST_IFRAME_SIZE"
                    fallbackMode="fixed"
                    viewportOffset={103}
                    initialHeight={600}
                    minHeight={300}
                    debounceMs={80}
                    style={{ width: '100%' }}
                    onLoad={handleIframeLoad}
                />
            )}
        </div>
    );
};
